import ToastService from "../../core/services/toaster-service";
import localStorageService from "../../core/services/local-storage-service";
import { LogOut } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import { isBusinessAdminUser } from "../../core/services/global-functions";
export function AdminSidebar({ isCollapsed, onToggle, navItems }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    ToastService.success("Logged out successfully");
    if (isBusinessAdminUser() === true) {
      localStorageService.clearAll();
      setTimeout(() => {
        navigate("/business/login");
      }, 800);
    } else {
      localStorageService.clearAll();
      setTimeout(() => {
        navigate("/admin/login");
      }, 800);
    }
    try {
      
    } catch (e) {
      // ignore
    }
    
    
  };
  return (
    <div
      className={`sidebar-nav d-flex flex-column ${
        isCollapsed ? "sidebar-collapsed" : "sidebar-expanded"
      }`}
    >
      {/* Header with Toggle */}
      <div className="sidebar-header">
        <h4 className="sidebar-title">{isCollapsed ? "" : "RescueRN"}</h4>
        <button
          className="toggle-btn"
          onClick={() => onToggle()}
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 6h18M3 12h18M3 18h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          ) : (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 6h18M3 12h18M3 18h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          )}
        </button>
      </div>

      {/* Navigation Items */}
      <nav className="flex-grow-1 px-3 py-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.id}
              className={({ isActive }) =>
                `nav-item${isActive ? " nav-item-active" : ""}`
              }
              title={isCollapsed ? item.label : ""}
              to={item.href}
            >
              <Icon size={20} className="nav-icon" />
              <span className="nav-text">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      {/* Logout Button - Bottom Right */}
      <div className="sidebar-footer">
        <button
          className="nav-item logout-btn"
          title={isCollapsed ? "Logout" : ""}
          onClick={handleLogout}
        >
          <LogOut size={20} className="nav-icon" />
          <span className="nav-text">Logout</span>
        </button>
      </div>
    </div>
  );
}
